<template>
  <div>
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="显隐列"
        placement="top"
        v-if="columns"
      >
        <div @click="showColumn()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12xsl.png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">显隐列</span>
        </div>
      </el-tooltip>
    </div>
    <!-- 检索 -->
    <div
      class="width100 f14 backwhite border-rd3 flex-betweenwrap"
      style="min-height: 72px"
      v-if="serchkey"
    >
      <el-form
        ref="ruleForm"
        size="small"
        label-width="100px"
        class="demo-ruleForm flexleft"
      >
        <el-form-item label="关键词">
          <el-input placeholder="请输入关键词" v-model="input"></el-input>
        </el-form-item>

        <div class="margin-left20 margin-top10 margin-bot10">
          <el-button type="primary" @click="submitForm()">检 索</el-button>
          <el-button @click="resetForm()">重 置</el-button>
        </div>
      </el-form>
    </div>
    <div
      class="
        width100
        backwhite
        pad-bot20 pad-top20
        margin-auto margin-top15
        border-rd3
        alldigital
      "
      v-if="total != 0"
    >
      <el-table
        :data="pages"
        stripe
        style="width: 98%"
        class="eltable margin-auto f14"
      >
        <el-table-column label="商标名称" v-if="columns[0].visible">
          <template slot-scope="scope">
            <span
              class="f14 cursorpointer bluecolor text-ellipsis"
              @click="todetails(scope.row)"
            >
              {{
                scope.row.trademark == null
                  ? ""
                  : scope.row.trademark.TrademarkName
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="国际分类" v-if="columns[1].visible">
          <template slot-scope="scope">
            <span class="f14">
              {{
                scope.row.trademark == null
                  ? ""
                  : scope.row.trademark.InternationalClass
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="trademark.RegNumber"
          label="商标号码"
          v-if="columns[2].visible"
        >
        </el-table-column>
        <el-table-column
          prop="trademark.ApplyDate"
          label="申请日期"
          v-if="columns[3].visible"
        >
        </el-table-column>
        <el-table-column
          prop="trademark.SpecialEndDate"
          label="到期日期"
          v-if="columns[4].visible"
        >
        </el-table-column>
        <el-table-column
          prop="trademark.RegisterName"
          label="申请人"
          v-if="columns[5].visible"
        >
        </el-table-column>
        <el-table-column
          prop="trademark.IsWellKnown"
          label="是否驰名商标"
          v-if="columns[6].visible"
        >
          <template slot-scope="scope">
            <span class="f14">
              {{
                scope.row.trademark == null
                  ? ""
                  : scope.row.trademark.IsWellKnown == ""
                  ? "否"
                  : scope.row.trademark.IsWellKnown
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" v-if="columns[7].visible">
          <template slot-scope="scope">
            <span
              class="f14 cursorpointer bluecolor margin-left10"
              @click="todialog(scope.row)"
            >
              <span>删除</span>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="flex-betweennowrap pad-top20 pad-right10" v-if="total != 0">
        <span class="bluecolor"></span>
        <el-pagination
          :hide-on-single-page="true"
          @size-change="handleSizeChange"
          @current-change="currentchange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="parseInt(per_page)"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
        >
        </el-pagination>
      </div>
    </div>
    <div
      class="width100 margin-auto backgroudFFF margin-top15"
      v-if="total == 0"
    >
      <el-empty
        :image="require('@/assets/barsvg/zwsj@3x.png')"
        :image-size="200"
        description="抱歉，没有搜到您想要的内容"
        class="heightempty"
        ><p style="position: relative; bottom: 60px" class="f14">
          暂无数据
        </p></el-empty
      >
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <el-dialog :title="title" :visible.sync="open" append-to-body width="40%">
      <el-transfer
        :titles="['全选', '全选']"
        v-model="value"
        :data="columns"
        @change="dataChange"
      ></el-transfer>
    </el-dialog>
  </div>
</template>
<script>
import {
  followtrademarkentfollow,
  followtrademarkremove,
} from "@/api/patent/patent.api";
import callback from "@/components/callback.vue";
import switchcore from "@/components/switchcore.vue";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      loading: true,
      errormessage: "",
      dialogVisiblenull: false,
      thisNum: 1,
      pages: [],
      total: 0,
      per_page: 0,
      currentPage: 1,
      pagination: false,
      centerDialogVisible: false,
      Remind: 0,
      behalf: 0,
      sell: 0,
      date: "",
      serchkey: true,
      input: "",
      companytitle: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      // 显隐数据
      value: [],
      // 弹出层标题
      title: "显示/隐藏",
      // 是否显示弹出层
      open: false,
      columns: [
        { key: 0, label: `商标名称`, visible: true },
        { key: 1, label: `国际分类`, visible: true },
        { key: 2, label: `商标号码`, visible: true },
        { key: 3, label: `申请日期`, visible: true },
        { key: 4, label: `到期日期`, visible: true },
        { key: 5, label: `申请人`, visible: true },
        { key: 6, label: `是否驰名商标`, visible: true },
        { key: 7, label: `操作`, visible: true },
      ],
    };
  },
  components: {
    callback,
    switchcore,
  },
  methods: {
    // 右侧列表元素变化
    dataChange(data) {
      for (let item in this.columns) {
        const key = this.columns[item].key;
        this.columns[item].visible = !data.includes(key);
      }
    },
    // 打开显隐列dialog
    showColumn() {
      this.open = true;
    },
    // input重 置
    resetForm() {
      this.input = null;
      this.thisNum = 1;
      followtrademarkentfollow({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 关键词检索
    submitForm() {
      followtrademarkentfollow({ _keywords: this.input, page: 1 }).then(
        (res) => {
          if (res.data.code == 200) {
            this.$loading.hide(); // 隐藏loading
            this.pages = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.drawer = false;
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        }
      );
    },

    // 删除
    todialog(row) {
      this.$confirm("此操作将删除此产品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          followtrademarkremove({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    Submitfrom() {},
    // 跳转详情
    todetails(row) {
      window.sessionStorage.setItem("treadlookout", row.trademark.ItemKey);
      this.$router.push({
        path: "/intellectual-property/trademarklookout-details",
      });
    },
    // 分页
    currentchange(val) {
      this.thisNum = val;
      followtrademarkentfollow({
        page: val,
        _keywords: this.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      followtrademarkentfollow({
        page: 1,
        limit: val,
        _keywords: this.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;

          this.drawer = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      followtrademarkentfollow({
        page: this.thisNum,
        _keywords: this.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.drawer = false;
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    this.companytitle = window.sessionStorage.getItem("companytitle");

    this.$loading.show(); // 显示loading
    followtrademarkentfollow({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.$loading.hide(); // 隐藏loading
        this.pages = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.drawer = false;
        this.$loading.hide(); // 隐藏loading
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
  color: #6a7589;
}
.hovercont:hover {
  background: #f7f9fc;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>